import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Image from "next/image";

import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";

import worldSchoolingImg from "@/public/images/families/world_schooling.jpg";


const WorldSchooling = () => {
  return (
    <>
      <PageHead title="World Schooling - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="World Schooling" text="World Schooling" />
          
          <div className=" bg-color-white mt--30 flex-center">
            <div className="container col-lg-8">
              <h4 className="title">
                Adoptando la educación mundial en un entorno campestre bilingüe
              </h4>
              <Image
                className="w-100 rbt-radius"
                src={worldSchoolingImg}
                width={407}
                height={638}
                property="true"
                alt="world schooling img"
              />
              <p className="description mt--30 mb--15">
                En Menfis, integramos la educación global en cada aspecto de nuestro enfoque educativo. Con un entorno único donde el aprendizaje trasciende el aula, combinamos excelencia académica con experiencias prácticas que conectan a los estudiantes con el mundo.
              </p>
              <p className="description mt--15 mb--15">
                Nuestros programas extracurriculares bilingües permiten a los estudiantes experimentar el mundo de manera inmersiva, desde exploraciones al aire libre hasta intercambios culturales y proyectos comunitarios. Así, desarrollan una comprensión profunda de diferentes culturas y problemas globales.
              </p>
              <p className="description mt--15">
                Este enfoque atrae a familias internacionales que valoran una educación integral. Nuestros programas no solo enseñan un segundo idioma, sino que también fomentan el pensamiento crítico, la creatividad y un sentido de ciudadanía global. En el Colegio Menfis, preparamos a nuestros estudiantes para prosperar en un mundo interconectado, ofreciendo una educación que es tanto académica como experiencial.
              </p>
              <h4 className="title mb--30">
                Únete a nosotros en Menfis y vive una nueva oportunidad para aprender, crecer y conectar con el mundo.
              </h4>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default WorldSchooling;
